var $1aa1ef112b9b61c7$var$SSR_NODE = 1;
var $1aa1ef112b9b61c7$var$TEXT_NODE = 3;
var $1aa1ef112b9b61c7$var$EMPTY_OBJ = {};
var $1aa1ef112b9b61c7$var$EMPTY_ARR = [];
var $1aa1ef112b9b61c7$var$SVG_NS = "http://www.w3.org/2000/svg";
var $1aa1ef112b9b61c7$var$id = (a)=>a;
var $1aa1ef112b9b61c7$var$map = $1aa1ef112b9b61c7$var$EMPTY_ARR.map;
var $1aa1ef112b9b61c7$var$isArray = Array.isArray;
var $1aa1ef112b9b61c7$var$enqueue = typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : setTimeout;
var $1aa1ef112b9b61c7$var$createClass = (obj)=>{
    var out = "";
    if (typeof obj === "string") return obj;
    if ($1aa1ef112b9b61c7$var$isArray(obj)) {
        for(var k = 0, tmp; k < obj.length; k++)if (tmp = $1aa1ef112b9b61c7$var$createClass(obj[k])) out += (out && " ") + tmp;
    } else {
        for(var k in obj)if (obj[k]) out += (out && " ") + k;
    }
    return out;
};
var $1aa1ef112b9b61c7$var$shouldRestart = (a, b)=>{
    for(var k in {
        ...a,
        ...b
    }){
        if (typeof ($1aa1ef112b9b61c7$var$isArray(a[k]) ? a[k][0] : a[k]) === "function") b[k] = a[k];
        else if (a[k] !== b[k]) return true;
    }
};
var $1aa1ef112b9b61c7$var$patchSubs = (oldSubs, newSubs = $1aa1ef112b9b61c7$var$EMPTY_ARR, dispatch)=>{
    for(var subs = [], i = 0, oldSub, newSub; i < oldSubs.length || i < newSubs.length; i++){
        oldSub = oldSubs[i];
        newSub = newSubs[i];
        subs.push(newSub && newSub !== true ? !oldSub || newSub[0] !== oldSub[0] || $1aa1ef112b9b61c7$var$shouldRestart(newSub[1], oldSub[1]) ? [
            newSub[0],
            newSub[1],
            (oldSub && oldSub[2](), newSub[0](dispatch, newSub[1]))
        ] : oldSub : oldSub && oldSub[2]());
    }
    return subs;
};
var $1aa1ef112b9b61c7$var$getKey = (vdom)=>vdom == null ? vdom : vdom.key;
var $1aa1ef112b9b61c7$var$patchProperty = (node, key, oldValue, newValue, listener, isSvg)=>{
    if (key === "style") for(var k in {
        ...oldValue,
        ...newValue
    }){
        oldValue = newValue == null || newValue[k] == null ? "" : newValue[k];
        if (k[0] === "-") node[key].setProperty(k, oldValue);
        else node[key][k] = oldValue;
    }
    else if (key[0] === "o" && key[1] === "n") {
        if (!((node.events || (node.events = {}))[key = key.slice(2)] = newValue)) node.removeEventListener(key, listener);
        else if (!oldValue) node.addEventListener(key, listener);
    } else if (!isSvg && key !== "list" && key !== "form" && key in node) node[key] = newValue == null ? "" : newValue;
    else if (newValue == null || newValue === false) node.removeAttribute(key);
    else node.setAttribute(key, newValue);
};
var $1aa1ef112b9b61c7$var$createNode = (vdom, listener, isSvg)=>{
    var props = vdom.props;
    var node = vdom.type === $1aa1ef112b9b61c7$var$TEXT_NODE ? document.createTextNode(vdom.tag) : (isSvg = isSvg || vdom.tag === "svg") ? document.createElementNS($1aa1ef112b9b61c7$var$SVG_NS, vdom.tag, props.is && props) : document.createElement(vdom.tag, props.is && props);
    for(var k in props)$1aa1ef112b9b61c7$var$patchProperty(node, k, null, props[k], listener, isSvg);
    for(var i = 0; i < vdom.children.length; i++)node.appendChild($1aa1ef112b9b61c7$var$createNode(vdom.children[i] = $1aa1ef112b9b61c7$var$maybeVNode(vdom.children[i]), listener, isSvg));
    return vdom.node = node;
};
var $1aa1ef112b9b61c7$var$patch = (parent, node, oldVNode, newVNode, listener, isSvg)=>{
    if (oldVNode === newVNode) ;
    else if (oldVNode != null && oldVNode.type === $1aa1ef112b9b61c7$var$TEXT_NODE && newVNode.type === $1aa1ef112b9b61c7$var$TEXT_NODE) {
        if (oldVNode.tag !== newVNode.tag) node.nodeValue = newVNode.tag;
    } else if (oldVNode == null || oldVNode.tag !== newVNode.tag) {
        node = parent.insertBefore($1aa1ef112b9b61c7$var$createNode(newVNode = $1aa1ef112b9b61c7$var$maybeVNode(newVNode), listener, isSvg), node);
        if (oldVNode != null) parent.removeChild(oldVNode.node);
    } else {
        var tmpVKid;
        var oldVKid;
        var oldKey;
        var newKey;
        var oldProps = oldVNode.props;
        var newProps = newVNode.props;
        var oldVKids = oldVNode.children;
        var newVKids = newVNode.children;
        var oldHead = 0;
        var newHead = 0;
        var oldTail = oldVKids.length - 1;
        var newTail = newVKids.length - 1;
        isSvg = isSvg || newVNode.tag === "svg";
        for(var i in {
            ...oldProps,
            ...newProps
        })if ((i === "value" || i === "selected" || i === "checked" ? node[i] : oldProps[i]) !== newProps[i]) $1aa1ef112b9b61c7$var$patchProperty(node, i, oldProps[i], newProps[i], listener, isSvg);
        while(newHead <= newTail && oldHead <= oldTail){
            if ((oldKey = $1aa1ef112b9b61c7$var$getKey(oldVKids[oldHead])) == null || oldKey !== $1aa1ef112b9b61c7$var$getKey(newVKids[newHead])) break;
            $1aa1ef112b9b61c7$var$patch(node, oldVKids[oldHead].node, oldVKids[oldHead], newVKids[newHead] = $1aa1ef112b9b61c7$var$maybeVNode(newVKids[newHead++], oldVKids[oldHead++]), listener, isSvg);
        }
        while(newHead <= newTail && oldHead <= oldTail){
            if ((oldKey = $1aa1ef112b9b61c7$var$getKey(oldVKids[oldTail])) == null || oldKey !== $1aa1ef112b9b61c7$var$getKey(newVKids[newTail])) break;
            $1aa1ef112b9b61c7$var$patch(node, oldVKids[oldTail].node, oldVKids[oldTail], newVKids[newTail] = $1aa1ef112b9b61c7$var$maybeVNode(newVKids[newTail--], oldVKids[oldTail--]), listener, isSvg);
        }
        if (oldHead > oldTail) while(newHead <= newTail)node.insertBefore($1aa1ef112b9b61c7$var$createNode(newVKids[newHead] = $1aa1ef112b9b61c7$var$maybeVNode(newVKids[newHead++]), listener, isSvg), (oldVKid = oldVKids[oldHead]) && oldVKid.node);
        else if (newHead > newTail) while(oldHead <= oldTail)node.removeChild(oldVKids[oldHead++].node);
        else {
            for(var keyed = {}, newKeyed = {}, i = oldHead; i <= oldTail; i++)if ((oldKey = oldVKids[i].key) != null) keyed[oldKey] = oldVKids[i];
            while(newHead <= newTail){
                oldKey = $1aa1ef112b9b61c7$var$getKey(oldVKid = oldVKids[oldHead]);
                newKey = $1aa1ef112b9b61c7$var$getKey(newVKids[newHead] = $1aa1ef112b9b61c7$var$maybeVNode(newVKids[newHead], oldVKid));
                if (newKeyed[oldKey] || newKey != null && newKey === $1aa1ef112b9b61c7$var$getKey(oldVKids[oldHead + 1])) {
                    if (oldKey == null) node.removeChild(oldVKid.node);
                    oldHead++;
                    continue;
                }
                if (newKey == null || oldVNode.type === $1aa1ef112b9b61c7$var$SSR_NODE) {
                    if (oldKey == null) {
                        $1aa1ef112b9b61c7$var$patch(node, oldVKid && oldVKid.node, oldVKid, newVKids[newHead], listener, isSvg);
                        newHead++;
                    }
                    oldHead++;
                } else {
                    if (oldKey === newKey) {
                        $1aa1ef112b9b61c7$var$patch(node, oldVKid.node, oldVKid, newVKids[newHead], listener, isSvg);
                        newKeyed[newKey] = true;
                        oldHead++;
                    } else if ((tmpVKid = keyed[newKey]) != null) {
                        $1aa1ef112b9b61c7$var$patch(node, node.insertBefore(tmpVKid.node, oldVKid && oldVKid.node), tmpVKid, newVKids[newHead], listener, isSvg);
                        newKeyed[newKey] = true;
                    } else $1aa1ef112b9b61c7$var$patch(node, oldVKid && oldVKid.node, null, newVKids[newHead], listener, isSvg);
                    newHead++;
                }
            }
            while(oldHead <= oldTail)if ($1aa1ef112b9b61c7$var$getKey(oldVKid = oldVKids[oldHead++]) == null) node.removeChild(oldVKid.node);
            for(var i in keyed)if (newKeyed[i] == null) node.removeChild(keyed[i].node);
        }
    }
    return newVNode.node = node;
};
var $1aa1ef112b9b61c7$var$propsChanged = (a, b)=>{
    for(var k in a)if (a[k] !== b[k]) return true;
    for(var k in b)if (a[k] !== b[k]) return true;
};
var $1aa1ef112b9b61c7$var$maybeVNode = (newVNode, oldVNode)=>newVNode !== true && newVNode !== false && newVNode ? typeof newVNode.tag === "function" ? ((!oldVNode || oldVNode.memo == null || $1aa1ef112b9b61c7$var$propsChanged(oldVNode.memo, newVNode.memo)) && ((oldVNode = newVNode.tag(newVNode.memo)).memo = newVNode.memo), oldVNode) : newVNode : $1aa1ef112b9b61c7$export$6f093cfa640b7166("");
var $1aa1ef112b9b61c7$var$recycleNode = (node)=>node.nodeType === $1aa1ef112b9b61c7$var$TEXT_NODE ? $1aa1ef112b9b61c7$export$6f093cfa640b7166(node.nodeValue, node) : $1aa1ef112b9b61c7$var$createVNode(node.nodeName.toLowerCase(), $1aa1ef112b9b61c7$var$EMPTY_OBJ, $1aa1ef112b9b61c7$var$map.call(node.childNodes, $1aa1ef112b9b61c7$var$recycleNode), $1aa1ef112b9b61c7$var$SSR_NODE, node);
var $1aa1ef112b9b61c7$var$createVNode = (tag, { key: key, ...props }, children, type, node)=>({
        tag: tag,
        props: props,
        key: key,
        children: children,
        type: type,
        node: node
    });
var $1aa1ef112b9b61c7$export$7c73462e0d25e514 = (tag, memo)=>({
        tag: tag,
        memo: memo
    });
var $1aa1ef112b9b61c7$export$6f093cfa640b7166 = (value, node)=>$1aa1ef112b9b61c7$var$createVNode(value, $1aa1ef112b9b61c7$var$EMPTY_OBJ, $1aa1ef112b9b61c7$var$EMPTY_ARR, $1aa1ef112b9b61c7$var$TEXT_NODE, node);
var $1aa1ef112b9b61c7$export$dda1d9f60106f0e9 = (tag, { class: c, ...props }, children = $1aa1ef112b9b61c7$var$EMPTY_ARR)=>$1aa1ef112b9b61c7$var$createVNode(tag, {
        ...props,
        ...c ? {
            class: $1aa1ef112b9b61c7$var$createClass(c)
        } : $1aa1ef112b9b61c7$var$EMPTY_OBJ
    }, $1aa1ef112b9b61c7$var$isArray(children) ? children : [
        children
    ]);
var $1aa1ef112b9b61c7$export$729c8b7179294ba = ({ node: node, view: view, subscriptions: subscriptions, dispatch: dispatch = $1aa1ef112b9b61c7$var$id, init: init = $1aa1ef112b9b61c7$var$EMPTY_OBJ })=>{
    var vdom = node && $1aa1ef112b9b61c7$var$recycleNode(node);
    var subs = [];
    var state;
    var busy;
    var update = (newState)=>{
        if (state !== newState) {
            if ((state = newState) == null) dispatch = subscriptions = render = $1aa1ef112b9b61c7$var$id;
            if (subscriptions) subs = $1aa1ef112b9b61c7$var$patchSubs(subs, subscriptions(state), dispatch);
            if (view && !busy) $1aa1ef112b9b61c7$var$enqueue(render, busy = true);
        }
    };
    var render = ()=>node = $1aa1ef112b9b61c7$var$patch(node.parentNode, node, vdom, vdom = view(state), listener, busy = false);
    var listener = function(event) {
        dispatch(this.events[event.type], event);
    };
    return (dispatch = dispatch((action, props)=>typeof action === "function" ? dispatch(action(state, props)) : $1aa1ef112b9b61c7$var$isArray(action) ? typeof action[0] === "function" ? dispatch(action[0], action[1]) : action.slice(1).map((fx)=>fx && fx !== true && (fx[0] || fx)(dispatch, fx[1]), update(action[0])) : update(action)))(init), dispatch;
};


const $c41c2b98c77a39c9$export$4162dbd8c730437 = 13;
const $c41c2b98c77a39c9$export$3ea83e27c899ea29 = {
    All: 0,
    Active: 1,
    Completed: 2
};
const $c41c2b98c77a39c9$export$31b40729666a4ae0 = ()=>{
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
const $c41c2b98c77a39c9$export$276debc7da0dca8f = (todos, id, ...todo)=>{
    const todoItem = todo[0];
    return todos.map((t)=>id === t.id ? Object.assign({}, t, todoItem) : t);
};


var $f5af55f21e73bb88$export$2e2bcd8739ae039 = {
    input: '',
    placeholder: 'What needs to be done?',
    todos: [],
    filter: (0, $c41c2b98c77a39c9$export$3ea83e27c899ea29).All
};


const $ccd7ed51d99d5897$var$STORAGE_KEY = 'todos-hyperapp';
var $ccd7ed51d99d5897$export$2e2bcd8739ae039 = {
    fetch: ()=>JSON.parse(localStorage.getItem($ccd7ed51d99d5897$var$STORAGE_KEY) || '[]'),
    save: (todos)=>localStorage.setItem($ccd7ed51d99d5897$var$STORAGE_KEY, JSON.stringify(todos))
};




var $51cc1fc1bc965072$export$2e2bcd8739ae039 = ()=>(0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('header', {
        class: 'header'
    }, [
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('h1', {}, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)('todos'))
    ]);



var $b37f104ff690817a$export$2e2bcd8739ae039 = ()=>(0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('footer', {
        class: 'info'
    }, [
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('p', {}, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)('Double-click to edit a todo')),
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('p', {}, [
            (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('span', {}, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)('Written by ')),
            (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('a', {
                href: 'https://dangthanh.org'
            }, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)('Dang Van Thanh'))
        ]),
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('p', {}, [
            (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('span', {}, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)('Part of ')),
            (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('a', {
                href: 'https://todomvc.com'
            }, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)('TodoMVC'))
        ])
    ]);





const $ee7dd417410d4b86$var$NewTodo = (value)=>({
        id: (0, $c41c2b98c77a39c9$export$31b40729666a4ae0)(),
        done: false,
        editing: false,
        value: value
    });
const $ee7dd417410d4b86$var$OnInput = (state, event)=>{
    const input = event.target.value;
    const newState = {
        ...state,
        input: input
    };
    return newState;
};
const $ee7dd417410d4b86$var$AddTodo = (state, event)=>{
    const todos = state.todos.concat($ee7dd417410d4b86$var$NewTodo(event.target.value));
    (0, $ccd7ed51d99d5897$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        input: '',
        todos: todos
    };
    return newState;
};
const $ee7dd417410d4b86$var$OnKeyDown = (state, event)=>{
    if (event.keyCode === (0, $c41c2b98c77a39c9$export$4162dbd8c730437) && event.target.value !== '') return $ee7dd417410d4b86$var$AddTodo(state, event);
    return state;
};
var $ee7dd417410d4b86$export$2e2bcd8739ae039 = (props)=>(0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('div', {}, [
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('input', {
            type: 'text',
            class: 'new-todo',
            onkeydown: $ee7dd417410d4b86$var$OnKeyDown,
            oninput: $ee7dd417410d4b86$var$OnInput,
            value: props.input,
            placeholder: props.placeholder
        })
    ]);





const $ff017e22fb74a115$var$ToggleAllTodo = (state, e)=>{
    let isCheckedAll = e.target.previousSibling.checked;
    isCheckedAll = !isCheckedAll;
    const todos = state.todos.map((t)=>{
        t.done = isCheckedAll;
        return t;
    });
    (0, $ccd7ed51d99d5897$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
var $ff017e22fb74a115$export$2e2bcd8739ae039 = ()=>(0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('div', {}, [
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('input', {
            type: 'checkbox',
            class: 'toggle-all',
            id: 'toggle-all'
        }),
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('label', {
            for: 'toggle-all',
            onclick: (state, e)=>$ff017e22fb74a115$var$ToggleAllTodo(state, e)
        }, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)('Mark all as complete'))
    ]);


var $137f7a6d622f12e0$export$2e2bcd8739ae039 = (props)=>(0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('section', {
        class: 'main'
    }, props.todos.filter((t)=>!t.done).length > 0 ? (0, $ff017e22fb74a115$export$2e2bcd8739ae039)() : (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)(''));







const $bf36d203d9a37436$var$RemoveTodo = (state, uuid)=>{
    const todos = state.todos.filter((t)=>uuid !== t.id);
    (0, $ccd7ed51d99d5897$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
const $bf36d203d9a37436$var$ToggleTodo = (state, uuid)=>{
    const todos = state.todos.map((t)=>uuid === t.id ? Object.assign({}, t, {
            done: !t.done
        }) : t);
    (0, $ccd7ed51d99d5897$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
const $bf36d203d9a37436$var$EditEnterTodo = (state, e, uuid)=>{
    const todos = (0, $c41c2b98c77a39c9$export$276debc7da0dca8f)(state.todos, uuid, {
        editing: true
    });
    (0, $ccd7ed51d99d5897$export$2e2bcd8739ae039).save(todos);
    const input = e.target.parentNode.parentNode.querySelector('.edit');
    input.focus();
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
const $bf36d203d9a37436$var$EditUpdateTodo = (state, e, uuid)=>{
    const todos = (0, $c41c2b98c77a39c9$export$276debc7da0dca8f)(state.todos, uuid, {
        editing: false,
        value: e.target.value
    });
    (0, $ccd7ed51d99d5897$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
const $bf36d203d9a37436$var$OnKeyUp = (state, e, todoId)=>{
    if (e.keyCode === (0, $c41c2b98c77a39c9$export$4162dbd8c730437)) return $bf36d203d9a37436$var$EditUpdateTodo(state, e, todoId);
    return state;
};
var $bf36d203d9a37436$export$2e2bcd8739ae039 = (todo)=>(0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('li', {
        class: [
            'todo',
            {
                completed: todo.done,
                editing: todo.editing
            }
        ]
    }, [
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('div', {
            class: 'view'
        }, [
            (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('input', {
                type: 'checkbox',
                class: 'toggle',
                checked: !!todo.done,
                onclick: [
                    $bf36d203d9a37436$var$ToggleTodo,
                    todo.id
                ]
            }),
            (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('label', {
                ondblclick: (state, e)=>$bf36d203d9a37436$var$EditEnterTodo(state, e, todo.id)
            }, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)(todo.value)),
            (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('button', {
                class: 'destroy',
                onclick: [
                    $bf36d203d9a37436$var$RemoveTodo,
                    todo.id
                ]
            }, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)(''))
        ]),
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('input', {
            type: 'text',
            class: 'edit',
            value: todo.value,
            onkeyup: (state, e)=>$bf36d203d9a37436$var$OnKeyUp(state, e, todo.id),
            onblur: (state, e)=>$bf36d203d9a37436$var$EditUpdateTodo(state, e, todo.id)
        })
    ]);


var $ef1b6769bc288c0e$export$2e2bcd8739ae039 = ({ todos: todos, filter: filter })=>(0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('ul', {
        class: 'todo-list'
    }, todos.filter((t)=>filter === (0, $c41c2b98c77a39c9$export$3ea83e27c899ea29).Completed ? t.done : filter === (0, $c41c2b98c77a39c9$export$3ea83e27c899ea29).Active ? !t.done : filter === (0, $c41c2b98c77a39c9$export$3ea83e27c899ea29).All).map((todo)=>(0, $bf36d203d9a37436$export$2e2bcd8739ae039)(todo)));





const $4cd5b1ad51eb60c8$var$ClearCompleted = (state)=>{
    const todos = state.todos.filter((t)=>!t.done);
    (0, $ccd7ed51d99d5897$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
const $4cd5b1ad51eb60c8$var$FilterTodo = (state, filter)=>{
    const newState = {
        ...state,
        filter: filter
    };
    return newState;
};
var $4cd5b1ad51eb60c8$export$2e2bcd8739ae039 = (props)=>(0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('footer', {
        class: 'footer'
    }, [
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('span', {
            class: 'todo-count'
        }, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)(`${props.todos.filter((t)=>!t.done).length} item left`)),
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('ul', {
            class: 'filters'
        }, Object.keys((0, $c41c2b98c77a39c9$export$3ea83e27c899ea29)).map((key)=>(0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('li', {}, (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('a', {
                class: props.filter === (0, $c41c2b98c77a39c9$export$3ea83e27c899ea29)[key] ? 'selected' : '',
                onclick: (state, e)=>$4cd5b1ad51eb60c8$var$FilterTodo(state, (0, $c41c2b98c77a39c9$export$3ea83e27c899ea29)[key])
            }, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)(key))))),
        props.todos.filter((t)=>t.done).length > 0 ? (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('button', {
            class: 'clear-completed',
            onclick: $4cd5b1ad51eb60c8$var$ClearCompleted
        }, (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)('Clear completed')) : (0, $1aa1ef112b9b61c7$export$6f093cfa640b7166)('')
    ]);


const $c2f7aa09f7e4eb41$var$App = (state)=>(0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('div', {
        class: 'container'
    }, [
        (0, $1aa1ef112b9b61c7$export$dda1d9f60106f0e9)('section', {
            class: 'todoapp'
        }, [
            (0, $51cc1fc1bc965072$export$2e2bcd8739ae039)(),
            (0, $ee7dd417410d4b86$export$2e2bcd8739ae039)(state),
            (0, $137f7a6d622f12e0$export$2e2bcd8739ae039)(state),
            (0, $ef1b6769bc288c0e$export$2e2bcd8739ae039)({
                todos: state.todos,
                filter: state.filter
            }),
            (0, $4cd5b1ad51eb60c8$export$2e2bcd8739ae039)(state)
        ]),
        (0, $b37f104ff690817a$export$2e2bcd8739ae039)()
    ]);
var $c2f7aa09f7e4eb41$export$2e2bcd8739ae039 = $c2f7aa09f7e4eb41$var$App;


(0, $f5af55f21e73bb88$export$2e2bcd8739ae039).todos = (0, $ccd7ed51d99d5897$export$2e2bcd8739ae039).fetch();
(0, $f5af55f21e73bb88$export$2e2bcd8739ae039).todos = (0, $f5af55f21e73bb88$export$2e2bcd8739ae039).todos.map((todo)=>{
    todo.editing = false;
    return todo;
});
const $6f40c3a58f594b58$var$InitApp = (state)=>state;
const $6f40c3a58f594b58$var$init = $6f40c3a58f594b58$var$InitApp((0, $f5af55f21e73bb88$export$2e2bcd8739ae039));
const $6f40c3a58f594b58$var$view = (state)=>(0, $c2f7aa09f7e4eb41$export$2e2bcd8739ae039)(state);
const $6f40c3a58f594b58$var$node = document.getElementById('app');
(0, $1aa1ef112b9b61c7$export$729c8b7179294ba)({
    init: $6f40c3a58f594b58$var$init,
    view: $6f40c3a58f594b58$var$view,
    node: $6f40c3a58f594b58$var$node
});


//# sourceMappingURL=repo.e173287e.js.map
